import { useLocation, useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Ban } from "lucide-react"

export default function Unauthorized() {
  const location = useLocation()
  const navigate = useNavigate()
  const { code = 401, message = "You are not authorized to access this resource" } = location.state || {}

  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      <div className="text-center space-y-6">
        <div className="flex justify-center">
          <Ban className="h-24 w-24 text-red-500" />
        </div>
        <div className="space-y-2">
          <h1 className="text-4xl font-bold tracking-tight">Unauthorized Access</h1>
          <p className="text-gray-600">{message}</p>
        </div>
        <div className="space-x-4">
          <Button 
            variant="outline" 
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>
          <Button 
            onClick={() => navigate("/")}
          >
            Return Home
          </Button>
        </div>
      </div>
    </div>
  )
}
